export default __webpack_public_path__ + "static/media/hero-section-northwestern-football-1440x540.d402b8b9.jpg";